import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    group: '',
    course: '',
    status: '',
  },
}

export const groupCoursesUI = createSlice({
  name: 'groupCoursesUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setGroup: (state, { payload }) => {
      state.tableFilters.group = payload
    },
    setCourse: (state, { payload }) => {
      state.tableFilters.course = payload
    },
    setStatus: (state, { payload }) => {
      state.tableFilters.status= payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setGroup,
  setCourse,
  setStatus,
  trackActiveFilters,
  clearAllFilters,
} = groupCoursesUI.actions

export default groupCoursesUI.reducer
